"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _ResultsTableModule = _interopRequireDefault(require("../../scss/ResultsTable.module.scss"));
function ResultsTableBody({
  results = [],
  columns = [],
  noResultsMsg = 'No results were returned'
}) {
  return results.length > 0 ? results.map((result, i) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `result-${i}`,
      className: (0, _helpers.classes)([_ResultsTableModule.default['results-table__row'], 'results-table__row'])
    }, columns.map(column => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_ResultsTableModule.default['results-table__item'], `results-table__${column.title.replace(' ', '-').toLowerCase()}`, 'results-table__item']),
        key: `result-${i}-${column.title}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_ResultsTableModule.default['results-table__mobile-label'], 'results-table__mobile-label'])
      }, column.title, ":"), Object.keys(result).includes(column.resultKey) ? result[column.resultKey] : '');
    }));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _ResultsTableModule.default['results-table__row']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ResultsTableModule.default['results-table__item'], _ResultsTableModule.default['results-table__no-results'], 'results-table__no-results'])
  }, noResultsMsg));
}
var _default = exports.default = ResultsTableBody;